export default "__VITE_ASSET__f600920b__"